// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2fiar","label":"CategoryService_label__208VE","location":"CategoryService_location__16V9W"};